import React, { createContext, useState, useEffect } from "react";
import all_product from "../Components/Assets/all_product";
import axios from "../lib/axios.js";

export const ShopContext = createContext(null);

const getDefaultCart = () => {
    let cart = {};
    for (let index = 0; index < all_product.length + 1; index++) {
        cart[index] = 0;
    }
    return cart;
};

const ShopContextProvider = (props) => {
    const [all_product, setAllProduct] = useState([]); 
    const [cartItems, setCartItems] = useState(getDefaultCart());
    const [wishlist, setWishlist] = useState([]); // ✅ Ensure wishlist is initialized

    const addToCart = (itemId) => {
        setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] + 1 }));
    };

    const removeFromCart = (itemId) => {
        setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] - 1 }));
    };

    // ✅ Fetch products from API
    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get("/products");
                setAllProduct(response.data.products || []);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };
        fetchProducts();
    }, []);

    // ✅ Add product to Wishlist with details
    const addToWishlist = (product, size, quantity, mainImage) => {
        const existingItem = wishlist.find((item) => item.id === product.id && item.size === size);

        if (!existingItem) {
            setWishlist([...wishlist, { 
                ...product, 
                size, 
                quantity, 
                image: mainImage || product.product_images?.[0]?.image_url 
            }]);
        }
    };

    // ✅ Remove item from Wishlist
    const removeFromWishlist = (itemId) => {
        setWishlist(wishlist.filter((item) => item.id !== itemId));
    };

    // ✅ Move from Wishlist to Cart
    const moveToCart = (item) => {
        setCartItems([...cartItems, item]); // Add to cart
        removeFromWishlist(item.id); // Remove from wishlist
    };


    const getTotalCartAmount = () => {
        let totalAmount = 0;
        for (const item in cartItems) {
            if (cartItems[item] > 0) {
                let itemInfo = all_product.find((product) => product.id === Number(item));
                if (itemInfo) {
                    totalAmount += itemInfo.new_price * cartItems[item];
                }
            }
        }
        return totalAmount;
    };

    const getTotalCartItems = () => {
        let totalItem = 0;
        for (const item in cartItems) {
            if (cartItems[item] > 0) {
                totalItem += cartItems[item];
            }
        }
        return totalItem;
    };

    const contextValue = {
        getTotalCartItems,
        getTotalCartAmount,
        all_product,
        cartItems,
        wishlist, // ✅ Ensure wishlist is included in the context
        addToWishlist,
        removeFromWishlist,
        moveToCart
    };

    return (
        <ShopContext.Provider value={contextValue}>
            {props.children}
        </ShopContext.Provider>
    );
};

export default ShopContextProvider;
